module.exports = __webpack_public_path__ + "img/پاکت-تحریر.006f1b25.png";